import React from 'react'
import PropTypes from 'prop-types'
import { Root } from './TableCell.styles'

/**
 * The TableCell's component.
 */
const TableCell = props => {
  const { align, children, colSpan, head, minWidth, padding, verticalAlign, width, color } = props

  return (
    <Root
      align={align}
      colSpan={colSpan}
      minWidth={minWidth}
      padding={padding}
      variant={head ? 'head' : 'body'}
      verticalAlign={verticalAlign}
      width={width}
      color={color}
    >
      {children}
    </Root>
  )
}

TableCell.defaultProps = {
  children: null,
  colSpan: 1,
  head: false,
  width: 'initial'
}
TableCell.propTypes = {
  align: PropTypes.oneOf(['inherit', 'left', 'center', 'right', 'justify']),
  children: PropTypes.node,
  colSpan: PropTypes.number,
  head: PropTypes.bool,
  color: PropTypes.string,
  minWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  padding: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  verticalAlign: PropTypes.oneOf(['baseline', 'bottom', 'initial', 'middle', 'top']),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
}

export default TableCell
